<template>
    <div class="project-detail-table-view">
        <ah-data-table
            class="project-detail-data-table"
            tableKey="project-detail-data-table"
            v-loading="isLoading"
            empty-text="沒有符合搜尋條件的專案"
            :columns="columns"
            :data="datas"
            :indexStart="(currPage - 1) * pageSize + 1"
            :showRefreshButton="true"
            @row-click="onDataRowClick"
            @refresh="$emit('refresh')"
        >
            <template slot="top-right-actions">
                <slot name="top-right-actions" />
            </template>
            <template v-slot:poo="scope">
                <span class="idx">{{ scope.row.poo }}</span>
            </template>
            <template v-slot:stG_STS="scope">
                <span v-if="scope.row.stG_STS === 1" class="ah-status done">結案</span>
                <span v-if="scope.row.stG_STS === 0" class="ah-status pending">進行中</span>
            </template>
            <template v-slot:pjcaT_NAM="scope">
                <span class="type-tag">{{ scope.row.pjcaT_NAM }}</span>
            </template>
            <template v-slot:nam="scope">
                <div>
                    <div class="projectName">
                        <span v-if="!scope.columns.pjcaT_NAM.visible" class="type-tag">{{ scope.row.pjcaT_NAM }}</span>
                        <span class="name">{{ scope.row.nam }}</span>
                    </div>
                    <div v-if="!scope.columns.vdR_NAM.visible" class="projectClient small">{{ scope.row.vdR_NAM }}</div>
                </div>
            </template>
            <template v-slot:vdR_NAM="scope">
                <span class="projectClient">{{ scope.row.vdR_NAM }}</span>
            </template>
            <template v-slot:timeProgress="scope">
                <ah-progress-cell-item :percentage="getTimeProgress(scope.row)">
                    <div>開始：{{ getFormatDate(scope.row.sdt) }}</div>
                    <div>結束：{{ getFormatDate(scope.row.edt) }}</div>
                </ah-progress-cell-item>
            </template>
            <template v-slot:amt="scope">
                <Money :v="scope.row.amt" class="project-amt" :cny="scope.row.cny" :precision="scope.row.cny === 'TWD' ? null : 4" />
                <div v-if="!scope.columns.cny.visible" class="cny">{{ scope.row.cny }}</div>
            </template>
            <template v-slot:totalPay="scope">
                <ah-progress-cell-item :percentage="getProfitProgress(scope.row)" :showProgress="scope.row.amT_PREOUT > 0">
                    <div class="space-between">已支出<Money round :v="scope.row.totalPay" /></div>
                    <div class="space-between">總預算<Money round :v="scope.row.amT_PREOUT" /></div>
                </ah-progress-cell-item>
            </template>
            <template v-slot:profit="scope">
                <ahProjectTableProfit :key="`profit-${scope.row.sno}`" :profit="getProfit(scope.row)" :percentage="getProfitPercentage(scope.row)" :isHidden="scope.row.stG_STS === 0" />
            </template>
            <template v-slot:invoice_status="scope">
                <ah-progress-cell-item :percentage="getInvoicePercentage(scope.row)">
                    <template slot="top-right-infos">
                        <div>
                            <span>已開 {{ scope.row.installmentInvoicedCount }}／{{ scope.row.installmentCount }} 期</span>
                            <el-tooltip v-if="scope.row.stG_STS === 1 && isInvoiceAmtEqual(scope.row)" effect="dark" placement="top" content="請檢查，已結案但發票總額不符">
                                <span style="margin-left: 5px" class="warning-icon el-icon-warning"></span>
                            </el-tooltip>
                        </div>
                    </template>
                    <div class="space-between">開立發票<Money :v="getValidIssuedInvoiceAmt(scope.row)" :cny="scope.row.cny" /></div>
                    <div class="space-between">未開發票<Money :v="getInvoiceNonIssuedAmt(scope.row.installments)" :cny="scope.row.cny" /></div>
                </ah-progress-cell-item>
            </template>
        </ah-data-table>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahProgressCellItem from '@/components/ui/ahProgressCellItem.vue';
import ahDataTable from '@/components/ui/ahDataTable.vue';
import ahProjectTableProfit from './ahProjectTableProfit.vue';

export default {
    components: {
        ahDataTable,
        ahProjectTableProfit,
        ahProgressCellItem,
    },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
        pageSize: {
            type: Number,
            default: 25,
        },
        currPage: {
            type: Number,
            default: 1,
        },
    },
    mounted() {},
    data() {
        return {
            columns: {
                index: {
                    label: '#',
                },
                poo: {
                    label: '系統編號',
                    width: 100,
                },
                customnumber: {
                    label: '自訂編號',
                    width: 100,
                    hideByDefault: true,
                },
                stG_STS: {
                    label: '專案狀態',
                    width: 80,
                },
                pjcaT_NAM: {
                    label: '專案類型',
                    width: 110,
                    hideByDefault: true,
                },
                nam: {
                    label: '專案名稱',
                    minWidth: 250,
                    disableHide: true,
                },
                vdR_NAM: {
                    label: '客戶',
                    hideByDefault: true,
                },
                stF_NAM: {
                    label: '專案經理',
                    width: 85,
                },
                projectAuditorName: {
                    label: '專案經辦人',
                    width: 85,
                    hideByDefault: true,
                },
                timeProgress: {
                    label: '專案時程',
                    width: 135,
                },
                amt: {
                    label: '專案總額',
                    align: 'right',
                    width: 115,
                },
                cny: {
                    label: '幣別',
                    width: 70,
                    hideByDefault: true,
                },
                totalPay: {
                    label: '實際支出 %',
                    width: 150,
                },
                profit: {
                    label: '毛利',
                    align: 'right',
                    width: 100,
                },
                invoice_status: {
                    label: '發票狀態',
                    width: 180,
                },
            },
        };
    },
    methods: {
        isInvoiceAmtEqual(row) {
            return row.invoicedAmount !== row.amt;
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        onDataRowClick(data) {
            this.$emit('row-click', data);
        },
        getFormatDate(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD');
        },
        getInvoiceNonIssuedAmt(installments) {
            return _.chain(installments)
                .filter((o) => !(o.invoiceStatus === 2 || o.invoiceStatus === 3))
                .sumBy('amt')
                .value();
        },
        getValidIssuedInvoiceAmt(row) {
            return row.invoicedAmount - this.getInvoiceDiscount(row.installments) - this.getVoidedInvoiceAmt(row.installments);
        },
        getVoidedInvoiceAmt(installments) {
            return _.chain(installments)
                .filter((o) => o.foO_DIS_CNL)
                .sumBy('amt')
                .value();
        },
        getInvoiceDiscount(installments) {
            return _.chain(installments)
                .filter((o) => !o.foO_DIS_CNL)
                .filter((o) => o.invoiceStatus === 2 || o.invoiceStatus === 3)
                .sumBy('foO_DIS_AMT')
                .value();
        },
        getProfit(row) {
            return row.amt * this.getCnyRat(row.cny) - this.getInvoiceDiscount(row.installments) - row.totalPay;
        },
        getProfitPercentage(row) {
            if (row.amt === 0) {
                return '--';
            }
            const p = Math.round((this.getProfit(row) / (row.amt * this.getCnyRat(row.cny) - this.getInvoiceDiscount(row.installments))) * 100);
            return Number.isNaN(p) ? '--' : p.toString();
        },
        getTimeProgress(row) {
            const start = row.sdt;
            const end = row.edt;
            const today = new Date().getTime();

            if (end === start) return 100;
            if (end < start) return 0;
            if (today < start) return 0;
            if (today >= end) return 100;

            return Math.round(((today - start) / (end - start)) * 100);
        },
        getProfitProgress(row) {
            if (row.totalPay === null || row.totalPay === 0 || row.amT_PREOUT === null || row.amT_PREOUT === 0) {
                return 0;
            }
            return Math.round((row.totalPay / row.amT_PREOUT) * 100);
        },
        getInvoicePercentage(row, zeroValue = 0) {
            const p = this.getInvoiceProgress(row);
            return Number.isNaN(p) ? zeroValue : p;
        },
        getInvoiceProgress(row) {
            if (row.installmentInvoicedCount === undefined || row.installmentCount === undefined) return 0;

            let validInvoicedTotal = 0;
            row.installments.forEach((item) => {
                if (!item.foO_DIS_CNL && (item.invoiceStatus === 2 || item.invoiceStatus === 3)) {
                    validInvoicedTotal += item.amt;
                }
            });

            return Math.round((validInvoicedTotal / row.amt) * 100);
        },
    },
};
</script>

<style lang="scss">
.project-detail-data-table {
    .projectClient {
        color: #888;
        font-size: 10pt;
        line-height: 100%;
        margin-top: 6px;

        &.small {
            color: #aaa;
            font-size: 9pt;
        }
    }
    .project-amt {
        font-size: 10pt;
    }
    .cny {
        color: #aaa;
    }
    .money {
        font-weight: 500;

        &.negative {
            color: rgb(222, 66, 66);
        }
    }
    // 實際支出欄位變色處理（已支出、毛利）
    .head-cell-totalPay {
        background-color: #fffafa;
    }
    .body-cell-totalPay {
        background-color: #fffafa;
    }
    .el-table__row:hover,
    .el-table__row.last-detail-dialog-target {
        .body-cell-totalPay {
            background-color: #fff2f2;
        }
    }
    .head-cell-totalPay,
    .body-cell-totalPay {
        border-left: 1px solid #f5f0f0;
    }
}
</style>
